import { Outlet, useLocation } from "react-router-dom";
import { SessionProvider } from "@/lib/auth";
import { BloqueiosProvider } from "@/lib/bloqueios";
import { PlanoProvider } from "@/lib/plano";
import { useSemMenuNativo } from "@/lib/nativo";
import { useTransicaoDeTela } from "@/lib/transicao";
import { useRolagem } from "@/lib/rolagem";

/** Faixa central: no desktop o app vira uma coluna de celular. */
export function Shell() {
  // Vale para o app inteiro, e por isso mora aqui: uma tela que esquecesse
  // de chamar seria a única que denuncia o navegador.
  useSemMenuNativo();

  const { pathname } = useLocation();
  const transicao = useTransicaoDeTela();

  /* Entrar numa tela é pelo topo; voltar volta pra onde a pessoa estava.
     Trocar de rota não mexe na rolagem sozinho, e sem isto quem estava no
     fim de um feed longo e abria um prato caía no meio da tela nova.

     NÃO é o `<ScrollRestoration/>` do React Router: ele restaura uma vez
     só, e nesse instante o feed ainda é um spinner numa página da altura
     da janela — o navegador corta o alvo pra 0 e a volta morre ali. O
     porquê inteiro está em `lib/rolagem.ts`. */
  useRolagem();

  return (
    <SessionProvider>
      <BloqueiosProvider>
        <PlanoProvider>
          {/* A `key` é o que faz a animação acontecer de novo. Trocar só a
              classe não reinicia animação nenhuma: o navegador só recomeça
              quando o elemento é outro, e sem a `key` o React reaproveita
              esta `div` de uma tela para a outra. */}
          <div key={pathname} className={`shell ${transicao}`.trim()}>
            <Outlet />
          </div>
        </PlanoProvider>
      </BloqueiosProvider>
    </SessionProvider>
  );
}
